import { E as EmblaCarousel } from './embla-carousel.esm-DpJzJcqm.js';
import { a as addAccessibility, A as Accessibility } from './accessibility-_zCLcLLO.js';
import { a as addPrevNextButtonClickHandlers } from './arrow-buttons-CGj8dylI.js';

class QuotesSlider extends HTMLElement {
  /** @type {import('embla-carousel').EmblaCarouselType | undefined} */
  #embla;
  /** @type {import('embla-carousel').EmblaCarouselOptions} */
  #options = {
    slidesToScroll: 1,
  };

  connectedCallback() {
    const viewport = this.querySelector('.embla__viewport');
    if (!viewport) return;

    this.#embla = this.#initEmbla(viewport);
    this.#initNavigation();
  }

  disconnectedCallback() {
    this.#embla?.destroy();
    this.#embla = undefined;
  }

  /**
   * Initializes the Embla carousel
   * @param {HTMLElement} viewport
   * @returns {import('embla-carousel').EmblaCarouselType}
   */
  #initEmbla(viewport) {
    const plugins = [Accessibility()];

    const embla = EmblaCarousel(viewport, this.#options, plugins);

    addAccessibility(embla);
    return embla;
  }

  /**
   * Initializes the navigation buttons
   * @returns {void}
   */
  #initNavigation() {
    const prevBtn = this.querySelector('[data-embla-button="prev"]');
    const nextBtn = this.querySelector('[data-embla-button="next"]');

    if (prevBtn && nextBtn) addPrevNextButtonClickHandlers(this.#embla, prevBtn, nextBtn);
  }
}

if (!customElements.get('quotes-slider')) {
  customElements.define('quotes-slider', QuotesSlider);
}
